import { SERVER_ERROR } from 'app/consts/messages';

const getErrorFromPromiseReason = (reason: any) => reason?.response?.data?.detail || SERVER_ERROR;

export default getErrorFromPromiseReason;
